export const compact = <T>(array: (T | null | undefined | false | '' | 0)[] | null | undefined): T[] => {
  if (!array) {
    return []
  } else {
    return array.filter(Boolean) as T[]
  }
}

type StylesObject = Record<string, string>

type ClassWithPredicateOf<TStylesObject extends StylesObject> = Partial<Record<keyof TStylesObject, boolean>>

export function m<TStyles extends StylesObject>(
  styles: TStyles,
  classNames: ClassWithPredicateOf<TStyles> | keyof TStyles,
  ...globalClassNames: Array<string | undefined>
) {
  const resultClassNames: Array<string | undefined> = []

  if (typeof classNames === 'string') {
    resultClassNames.push(styles[classNames])
  } else {
    const _className = classNames as Partial<Record<keyof TStyles, boolean>>

    for (const className in _className) {
      const predicate = _className[className]

      if (predicate && styles[className]) {
        resultClassNames.push(styles[className])
      }
    }
  }

  return compact(resultClassNames.concat(globalClassNames)).join(' ') || undefined
}
